// Hammer.Manager mock for use in environments without `document` / `window`.
export default function HammerManagerMock(m) {
  var instance = {};

  var chainedNoop = function chainedNoop() {
    return instance;
  };

  instance.get = function () {
    return null;
  };

  instance.set = chainedNoop;
  instance.on = chainedNoop;
  instance.off = chainedNoop;
  instance.destroy = chainedNoop;
  instance.emit = chainedNoop;
  return instance;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mjolnir.js/dist/esm/utils/hammer-manager-mock.js
// module id = 173
// module chunks = 0